import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button
} from "@material-ui/core";

const DialogWindow = ({ errorset, open, handleClose, text }) => {
  return (
    <Dialog
      open={errorset ? !open : open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ fontFamily: "Manrope" }}>
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus style={{ fontFamily: "Manrope" }}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogWindow;
